import React from "../../../../lib/teact/teact";
import { DetailsDataItem } from "../../utils/sortUtils";
import { Remove2C3C4C } from "../../utils/common";

export type DetailsRowViewModel = {
  dai: string;
  loai: string;
  so: string;
  diem: string;
  trung: string;
  isTrung: boolean;
};

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function buildDetailsRowViewModel(row: DetailsDataItem): DetailsRowViewModel {
  return {
    dai: `${row.daiId1}${row.daiId2 !== "" ? "." : ""}${row.daiId2}`,
    loai: Remove2C3C4C(row.loaiCuocId),
    so: String(row.soCuoc ?? ""),
    diem: String(row.diem ?? ""),
    trung: String(row.trung ?? ""),
    isTrung: row.trung !== 0,
  };
}

export function renderDetailsRow(viewRow: DetailsRowViewModel): JSX.Element {
  return (
    <div className={`details-row${viewRow.isTrung ? " trung" : ""}`}>
      <div className="table-cell">{viewRow.dai}</div>
      <div className="table-cell">{viewRow.loai}</div>
      <div className="table-cell">{viewRow.so}</div>
      <div className="table-cell right">{viewRow.diem}</div>
      <div className="table-cell right">{viewRow.trung}</div>
    </div>
  );
}

export function buildDetailsReportHtml(rows: DetailsDataItem[]): string {
  const rowHtml = rows
    .map((row) => {
      const vm = buildDetailsRowViewModel(row);
      return `
      <div class="details-row${vm.isTrung ? " trung" : ""}">
        <div class="table-cell">${escapeHtml(vm.dai)}</div>
        <div class="table-cell">${escapeHtml(vm.loai)}</div>
        <div class="table-cell">${escapeHtml(vm.so)}</div>
        <div class="table-cell right">${escapeHtml(vm.diem)}</div>
        <div class="table-cell right">${escapeHtml(vm.trung)}</div>
      </div>`;
    })
    .join("");

  return `
  <div class="details-report-export">
    <div class="details-row">
      <div class="details-header">Đài</div>
      <div class="details-header">Loại</div>
      <div class="details-header">Số</div>
      <div class="details-header right">Điểm</div>
      <div class="details-header right">Trúng</div>
    </div>
    ${rowHtml}
  </div>`;
}
